import React, { useState } from "react";
import"../componnetsCss/Withdrewl.css"
import { Button, Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { FaAngleRight, FaPhoneAlt } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import firstImg from "../images/asda.jpg";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { getDatabase, onValue, ref, update } from "firebase/database";
import { app } from "../Firebase";
import { ToastContainer, toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import "react-toastify/dist/ReactToastify.css";
import { FaTriangleExclamation } from "react-icons/fa";
// import ReactPlayer from "react-player";
// import withdrewVideo from "../videos/withdrew.mp4";

const Withdrewl = () => {
  const [show, setShow] = useState();
  const location = useLocation().state.name;
  const user = location;
  //// For user Balance
  const [balance, setBalance] = useState();
  ////For userName
  const [userName, setUserName] = useState();
  ////For withdrewl target value
  const [selectedValue, setasd] = useState();
  ///For show withdrewl panding data after withdrewal button click
  const [showData, setshowData] = useState();
  ///For Withdrewl Amount
  const [WithdrewlAm, setWithdrewlAm] = useState();
  //For Account Number
  const [AccntNu, setAccntNu] = useState();
  ///For Account Name
  const [AccntName, setAccntName] = useState();
  ///For Account Name like easypaisa or jazzcash
  const [Accnt, setAccnt] = useState();
  //// For account rending information
  const [accountName, setaccountName] = useState();
  const [accountNumber, setaccountNumber] = useState();
  const [accountBranch, setaccountBranc] = useState();
  const [accshow, setaccshow] = useState(false);
  //////////////// for changing withdrewl value
  const [pkg1check, setpkg1check] = useState()
  const [pkg2check, setpk2check] = useState()
  const [pkg3check, setpkg3check] = useState()
  const [pkg4check, setpkg4check] = useState()
  //////////for fatch withdrewl value
  const [withdrawValue1, setwithdrawValue1] = useState()
  const [withdrawValue2, setwithdrawValue2] = useState()
  const [withdrawValue3, setwithdrawValue3] = useState()
  const [withdrawValue4, setwithdrawValue4] = useState()
  const [withdrawValue5, setwithdrawValue5] = useState()
  console.log(withdrawValue1)
  console.log(withdrawValue2)
  console.log(withdrawValue3)
  console.log(withdrawValue4)
  console.log(withdrawValue5)

  let currentDateTime = new Date().toISOString();
  let currentDate = new Date().getDate();
  let currentHours = new Date().getHours();
  let currentMinutes = new Date().getMinutes();
  let currentSecond = new Date().getSeconds();

  console.log(showData);

  if (balance === undefined) {
    console.log(`haleo`);
  } else {
    const db = getDatabase(app);
    const aasss = ref(db, `${user}`);

    const a = balance;
    update(aasss, {
      Bal: balance,
    });
  }

  useEffect(() => {
    ////////For Exist User Data Func

    const readDataUser = () => {
      const db = getDatabase(app);
      const starCountRef = ref(db, user);
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        const assd = data.userid;

        setBalance(data.Bal);
        setUserName(data.username);
        setshowData(data.Withdrewl.withdrewl);
        setShow(data.Withdrewl.withdrewlBtnShow);
        setWithdrewlAm(data.Withdrewl.withdrewlAmount);
        setaccountNumber(data.accountInfo.Number);
        setaccountName(data.accountInfo.Name);
        setaccountBranc(data.accountInfo.Account);
        setpkg1check(data.Msg.pack1)
        setpk2check(data.Msg.pack2)
        setpkg3check(data.Msg.pack3)
        setpkg4check(data.Msg.pack4)

        setwithdrawValue1(data.WithdrewlAmount.value1)
        setwithdrawValue2(data.WithdrewlAmount.value2)
        setwithdrawValue3(data.WithdrewlAmount.value3)
        setwithdrawValue4(data.WithdrewlAmount.value4)
        setwithdrawValue5(data.WithdrewlAmount.value5)

      });
    };
    readDataUser();
  }, []);


  if (pkg4check == true) {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/WithdrewlAmount`);

    update(aas, {
      value1: 3000,
      value2: 4000,
      value3: 5000,
      value4: 6000,
      value5: 9000,
    });
  }
  else if (pkg3check == true) {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/WithdrewlAmount`);

    update(aas, {
      value1: 1800,
      value2: 3600,
      value3: 5650,
      value4: 7500,
      value5: 8000,
    });
  }
  else if (pkg2check == true) {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/WithdrewlAmount`);

    update(aas, {
      value1: 1000,
      value2: 1500,
      value3: 1899,
      value4: 2200,
      value5: 3200,
    });
  }
  else if (pkg1check == true) {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/WithdrewlAmount`);

    update(aas, {
      value1: 165,
      value2: 350,
      value3: 550,
      value4: 650,
      value5: 960,
    });
  }


  if (balance >= selectedValue) {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/Withdrewl`);

    update(aas, {
      withdrewlBtnShow: true,
    });
  } else {
    const db = getDatabase(app);
    const aas = ref(db, `${user}/Withdrewl`);

    update(aas, {
      withdrewlBtnShow: false,
    });
  }
  const withdrewlBtn = (a) => {
    const as = setBalance(balance - selectedValue);

    const db = getDatabase(app);
    const aasas = ref(db, `Withdrewl/${user}`);
    update(aasas, {
      withdrewl: selectedValue,
      userName: userName,
      data: currentDate,
      time: `${currentHours}H : ${currentMinutes}M : ${currentSecond}S`,
    });
    setTimeout(() => {
      const db = getDatabase(app);
      const aaasas = ref(db, `${user}/Withdrewl`);

      update(aaasas, {
        withdrewl: true,
      });
    }, 150);
  };
  const submitHandler = (event) => {
    event.preventDefault();
  };

  const submitAccInfo = () => {
    // AccntNu
    // AccntName
    // Accnt
    if (AccntNu == undefined) {
      const notify = () => toast.warn("Enter Account Number!");
      notify();
    } else if (AccntName == undefined) {
      const notify = () => toast.warn("Enter Account Name!");
      notify();
    } else if (Accnt == undefined) {
      const notify = () => toast.warn("Select easypaisa ir jazzcash ");
      notify();
    } else {
      const notify = () => toast.success("Your Info Add SuccessFully");
      notify();
      AccInfoForRander();
      setTimeout(() => {
        const db = getDatabase(app);
        const aaasas = ref(db, `${user}/accountInfo`);

        update(aaasas, {
          Number: AccntNu,
          Name: AccntName,
          Account: Accnt,
        });
      }, 150);
    }
  };
  const AccInfoForRander = () => {
    setaccshow(true);
  };

  return (
   <div className="app-dashboard">
  {/* Toast Container for Notifications */}
  <ToastContainer position="top-right" autoClose={500} theme="colored" />


  <div className="content-container">
    {/* Welcome Header */}
    <header className="welcome-header">
      <h3 className="greeting">Assalam o Alaikum</h3>
      <h1 className="user-display-name">{userName}</h1>
    </header>

    {/* Balance & Withdrawal Stats Cards */}
    <div className="balance-grid">
      <div className="glass-card balance-card">
        <span className="card-label">Current Balance</span>
        <div className="card-value">Rs. {balance}</div>
      </div>
      <div className="glass-card withdraw-card highlight">
        <span className="card-label">Pending Payout</span>
        <div className="card-value">Rs. {selectedValue}</div>
      </div>
    </div>

    {/* Withdrawal Control Section */}
    <section className="action-section">
      {showData ? (
        <div className="pending-status-box">
          <div className="neon-spinner"></div>
          <h2>Withdrawal is Pending...</h2>
        </div>
      ) : (
        <div className="withdrawal-box">
          <h4 className="section-title">Select Amount to Withdraw</h4>
          <div className="amount-grid">
            {[withdrawValue1, withdrawValue2, withdrawValue3, withdrawValue4, withdrawValue5].map((val, index) => (
              <label key={index} className="amount-chip">
                <input
                  type="radio"
                  name="amount"
                  value={val}
                  onChange={(e) => setasd(e.target.value)}
                />
                <span className="chip-design">{val}</span>
              </label>
            ))}
          </div>

          {show && (
            <button className="main-action-btn" onClick={withdrewlBtn}>
              Confirm Withdrawal
            </button>
          )}
        </div>
      )}

      <p className="tax-info-text">
        <FaAngleRight /> 4% Transaction Tax applies
      </p>
    </section>

    {/* User Account Info Display */}
    <div className="account-details-card">
      <h5>Active Payout Account</h5>
      <div className="detail-row"><span>Name:</span> <strong>{accountName}</strong></div>
      <div className="detail-row"><span>Number:</span> <strong>{accountNumber}</strong></div>
      <div className="detail-row"><span>Gateway:</span> <strong>{accountBranch}</strong></div>
    </div>

    {/* Account Configuration Form */}
    <div className="glass-card form-container">
      <h2 className="form-header">
        {accshow ? "Update Payout Method" : "Setup Payout Method"}
      </h2>
      <div className="premium-input-group">
        <label>Account Holder Name</label>
        <input type="text" placeholder="e.g. Ali Khan" onChange={(e) => setAccntName(e.target.value)} />
      </div>

      <div className="premium-input-group">
        <label>Mobile Number</label>
        <input type="text" placeholder="e.g. 03001234567" onChange={(e) => setAccntNu(e.target.value)} />
      </div>

      <div className="gateway-selector">
        <label className="gateway-option">
          <input type="radio" name="acc" value="easypaisa" onChange={(e) => setAccnt(e.target.value)} />
          <div className="gateway-box">Easypaisa</div>
        </label>
        <label className="gateway-option">
          <input type="radio" name="acc" value="jazzcash" onChange={(e) => setAccnt(e.target.value)} />
          <div className="gateway-box">JazzCash</div>
        </label>
      </div>

      <button className="submit-form-btn" onClick={submitAccInfo}>Save Details</button>
    </div>

    {/* Total History Stat */}
    <div className="total-history-footer">
      <p>Total Life-time Withdrawals: <span className="highlight-text">{WithdrewlAm} Rs</span></p>
    </div>
  </div>
</div>
  );
};

export default Withdrewl;
